import React, { Component } from 'react';
import { dateHelper, constant } from "../helpers";
import { UploadPanel, UploadDisplay } from "../components";
import './Site.css';
export default class ProductionUpload extends Component {
  constructor(props) {
    super(props);
    this.state = {
      message: null,
      messageColor: null,
      isMessageVisible: false,
      importProcessing: false,
      uploadResults: null,
      importDate: dateHelper.getUtcDate(),
      searchDate: dateHelper.getUtcDate(),
      searchSku: '',
      searchMonthTotal: null,
      editShippingData: null,
      filters: [],
      pagedList: null,
      sortColumn: "DateOccurred",
      sortAscending: true,
      editMode: true,
      showUploadPanel: false
    }
  }
  render() {
    return (
      <div>
        {this.state.showUploadPanel && (
          <UploadPanel
            uploadType={constant.uploadType.production}
            onCancel={() => this.setState({ showUploadPanel: false })}
            onSuccess={this.onSearchDateChange}
          />
        )}
        <UploadDisplay
          uploadType={constant.uploadType.production}
          saveApiRoute={"Product/SaveProductionCount"}
          apiRoute={"Product/GetProductionSummary"}
        />
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/ProductionUpload.js